/* eslint-disable @reatom/unit-naming-rule */
import { action, noop } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { limitOrderRegistry } from '@root/entities/limit-order/atoms'
import { Network } from '@root/entities/network'
import { reatomPaginated } from '@root/shared/lib'

import { fetchLimitOrdersRequestAction } from './atoms/limit-order-requests'

import type { LimitOrder, LimitOrderModel } from '@root/entities/limit-order'
import type { WalletId } from '@root/entities/wallet'

export const reatomLimitOrders = ({
  walletId,
  network,
  status,
  type,
}: {
  walletId: WalletId
  network: Network.Network
  status: LimitOrder.Status | undefined
  type: LimitOrder.Type | undefined
  name?: string
}) => {
  const ordersStateAtom = reatomPaginated({
    loadItems: async (ctx, { limit, offset }) => {
      const result = await fetchLimitOrdersRequestAction(ctx, {
        walletIds: [walletId],
        network: Network.toDto(network),
        type,
        status,
        limit,
        offset,
      })

      return result.pipe(
        Result.map((it) => {
          const orders = it.data.map((dto) => {
            return limitOrderRegistry.resolve(ctx, dto)
          })
          return orders
        }),
      )
    },

    name: `limitOrders_${network}_${walletId}`,
  })

  return ordersStateAtom
}

export type ReatomLimitOrders = ReturnType<typeof reatomLimitOrders>

export const openEditLimitOrderDrawerEvent = action<
  [{ order: LimitOrderModel }]
>(noop, 'openEditLimitOrderDrawerEvent')

export * from './atoms'
